import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { handleError, handleSuccess } from '../../../helpers/utils';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import DateFnsUtils from '@date-io/date-fns';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { es } from 'date-fns/locale';
import { useSelector } from 'react-redux';
import { handleConfirmModal } from '../../../helpers/utils';
import { Grid } from '@mui/material';
import { registerProcess } from '../../../actions/process';
import moment from 'moment';
import {
	calculateProgresses,
	getSubBiasInfo,
	updateSubBias,
} from '../../../actions/biases';
import { getDataByUrl } from '../../../actions/catalogs';

export const ProcessForm = ({
	open,
	handleClose,
	subbiasId = null,
	refresh,
	collapseClose = null,
	changeKeyAccordion = null,
}) => {
	// Form
	const [entryDate, setEntryDate] = React.useState(null);
	const [finalDate, setFinalDate] = React.useState(null);
	const [subbias, setSubbias] = React.useState(null);
	const [unitsCompleted, setUnitsCompleted] = React.useState(0);

	// States
	const { user } = useSelector((state) => state);
	const { area: areas = [] } = useSelector((state) => state.catalogs);

	// Load data
	React.useEffect(() => {
		if (subbiasId) {
			getSubBiasInfo(subbiasId).then(({ data }) => {
				setSubbias(data);
			});
		}
	}, [subbiasId]);

	const handleGetAreaName = (userArea) =>
		areas?.find((area) => area?.id === userArea)?.name || '-';

	const handleSave = () => {
		handleClose();
		changeKeyAccordion('no');
		handleConfirmModal(
			'Precaución',
			'¿Seguro que deseas guardar el proceso?',
			'info',
			'Sí, guardar'
		).then(({ isConfirmed }) => {
			if (isConfirmed) {
				// Get user area's name
				const userAreaName = handleGetAreaName(user.area.id);

				// Check if there's some process with that area
				getDataByUrl(
					`/api/bias/individual-area/?bias=${subbias.bias}&search=${userAreaName}`
				).then(({ data }) => {
					// Assign results
					const individualArea = data.results;

					// Match the individual area with the user's area
					if (individualArea.length > 0) {
						registerProcess({
							entry_date: moment(entryDate).format('YYYY-MM-DD'),
							final_date: moment(finalDate).format('YYYY-MM-DD'),
							created_by: user.id,
							subbias: parseInt(subbiasId),
							area: individualArea[0].id,
						})
							.then(() => {
								updateSubBias(subbiasId, {
									...subbias,
									size: subbias.size.id,
									created_by: subbias.created_by.id,
									units_completed:
										subbias.units_completed +
										parseInt(unitsCompleted),
								})
									.then(() => {
										console.log('OK updating subbias');
										calculateProgresses(subbiasId)
											.then(() => {
												// Feedback success
												handleSuccess(
													'Proceso guardado'
												);

												// Collapse accordion
												collapseClose(true);
												changeKeyAccordion(
													`subbias-${subbiasId}`
												);

												// Refresh data
												refresh();
											})
											.catch((error) => {
												// Feedback error
												handleError(
													error,
													'No se pudo calcular el progreso'
												);
											});
									})
									.catch((error) => {
										// Feedback error
										handleError(error, 'Error en talla');
									});
							})
							.catch((error) => {
								// Feedback error
								handleError(
									error,
									'No se pudo guardar el proceso'
								);
							});
					} else {
						// Feedback error
						handleError(error, 'No se encontró el área individual');
					}
				});
			}
		});
		setEntryDate(null);
		setFinalDate(null);
	};

	const TextFieldComponent = (params, label) => (
		<TextField
			fullWidth
			required
			margin='normal'
			{...params}
			label={label}
		/>
	);

	return (
		<Dialog open={open} onClose={handleClose} maxWidth='sm'>
			<LocalizationProvider
				dateAdapter={AdapterDateFns}
				adapterLocale={es}
				utils={DateFnsUtils}
			>
				{subbias && (
					<>
						{' '}
						<DialogTitle>{subbias.name}</DialogTitle>
						<DialogContent>
							<DialogContentText>
								Nuevo proceso del área "
								{handleGetAreaName(user.area.id)}".
							</DialogContentText>
							<Grid container spacing={2} className='mt-2'>
								<Grid item xs={6}>
									<DesktopDatePicker
										fullWidth
										label='Fecha de asignación'
										inputFormat='dd/MM/yyyy'
										// Cambiar a false
										disablePast
										value={entryDate}
										onChange={(value) => {
											setEntryDate(value);
										}}
										renderInput={(params) =>
											TextFieldComponent(
												params,
												'Fecha de asignación'
											)
										}
									/>
								</Grid>
								<Grid item xs={6}>
									<DesktopDatePicker
										fullWidth
										label='Fecha de entrega'
										inputFormat='dd/MM/yyyy'
										// Cambiar a false
										disablePast
										value={finalDate}
										onChange={(value) => {
											setFinalDate(value);
										}}
										renderInput={(params) =>
											TextFieldComponent(
												params,
												'Fecha de entrega'
											)
										}
									/>
								</Grid>
								<Grid item xs={6}>
									<TextField
										required
										fullWidth
										label='Unidades terminadas'
										value={unitsCompleted}
										onChange={({ target }) =>
											setUnitsCompleted(target.value)
										}
									/>
								</Grid>
							</Grid>
						</DialogContent>
						<DialogActions>
							<Button onClick={handleClose}>Cancelar</Button>
							<Button onClick={handleSave}>Guardar</Button>
						</DialogActions>
					</>
				)}
			</LocalizationProvider>
		</Dialog>
	);
};
